module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Chapter-Title-Page-Break--Body-",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("THE FIREBRAND ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Chapter-Subtitle--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("PRIYA SHARMA")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry Ellard"), _c('span', {
    staticClass: "Bold-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(", ")]), _vm._v("aged eighteen, can’t believe that he’s just witnessed three people die, only hours ago.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One of them was Rebecca Saunders. The Firebrand. How he loved to watch her as flames danced across her outstretched hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry strikes the pink head of a match against the side of the matchbox. There’s the flare and the familiar smell as sulphur and phosphorus combine. He passes a finger through the flame.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bearable")]), _vm._v(", he thinks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry tries to hold his finger in the flame but fails. He throws the match into the ashtray and watches it burn to a shriveled stick, his scorched finger in his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Three deaths. What combination of murder, suicide, and accident has he seen?")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first time he saw Rebecca was as he wandered through the crowd. She stood, her sequined costume winking in the sunlight, handing out flyers. A remarkable woman, able to withstand flames and who looked right at him and smiled as though he were the most handsome man she’d ever seen. She reached out and touched the livid purple birthmark that covers the left side of his face with a fingertip. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Equally remarkable is that she’s died in a pyre that’s consumed both her and Leo Saunders. Henry could hear the man roaring from the heart of the inferno. The thing Henry doesn’t understand is that Rebecca didn’t scream. Not even once.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Henry?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He looks up to see a waitress standing over him. Her gaze flicks from his eyes to his birthmark. “I’m Katherine. From your history class.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, hi.” He’s chosen this café to avoid such encounters. “I work here,” she adds, as if an explanation is required.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry tips his face away from her to hide the unsightly port wine stain. The gesture makes him look reticent at best, dismissive at worst, but it’s instinctive.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What are you having?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Black coffee, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Katherine hesitates, as though she has more to say. He wants her to leave him alone. It’s too complex, trying to work out whether her friendliness is genuine, mockery, or from pity when his mind is so full of the recently deceased Rebecca, Leo, and Christos Saunders. He lights another match and stares at the flame until Katherine walks away.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry Ellard, at sixty-four, feels indignant that he’s had to start afresh. His new house has no claim to his history. It’s not where he embarked on or ended family life. It’s not where he and Katherine raised their child or where Henry had a heart attack, pain crushing him to the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The house does have charm though. It’s at the end of a lane, single storied, with a veranda that wraps around the whole building. There’s a galley kitchen and two bedrooms, although the spare one’s never used. The lounge window overlooks the woods. The trees are company. The room’s unfit for entertaining as he’s made it his sanctuary. One wall’s covered with shelves laden with box files. The desk that was built for two dominates the room. Henry used to sit opposite Katherine, then his wife, as they marked student papers late into the night.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A single poster, an original, acts as the room’s sole decoration.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Something new and unique comes to Paradise. The Firebrand! The world’s only burning girl!")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca Saunders has been rendered half woman, half phoenix in the illustration. Her costume’s pinched at the waist and her sloping tail is red and gold. She smiles, despite being on fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry always keeps his own personal copy of his book to hand. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Firebrand: Death in Paradise ")]), _vm._v("by Henry Ellard. His ex-wife once threw it at him during a fight.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your responsibility’s to us, not the past,” Katherine had shouted.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She was across the room upending files of photos, programs, and transcribed interviews. He lunged after her, trying to protect his archive of lost lives.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry’s book is stuffed with original snapshots, letters, and his own handwritten notes. He flicks through until he finds his favorite photo, pressed like a leaf between the pages. A cropped version’s reprinted within the book"), _c('span', {
    staticClass: "Bold-Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(", ")]), _vm._v("but the original is of the whole Saunders inner circle, dressed for dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This group portrait was taken against the backdrop of Paradise, a mile-long plot of land that was part fun fair, part circus, part county show. There’s Rebecca, Christos, and their dog sitting on a picnic bench. The Russian trapeze artists, Nikolai and Lara, are standing beside them. Nikolai’s arm is around Lara’s neck, pulling her close. His lips are planted on her cheek and Henry can never decide if she looks annoyed or amused. Whether they were sister and brother, or lovers, remains a mystery. The Giant, real name Jacob Stein, has dark eyes in a long face. Nancy Fotheringale, the Wax Lady, leans on his arm. There’s Rollo, the clown, face unpainted and hair slick with pomade. And Leo Saunders, of course, at the center of everything. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry looks at the photo, back across forty-six years, and wonders if his memories have been colored by research. These people are vivid in his mind, even though he never knew them, just orbited them during his eighteenth summer, every spare penny and evening spent in Paradise. He wasn’t a freak when he walked among them. Disfigurements were a mark of pride among this wondrous clan, like the Wax Lady’s melted face or the long, cadaverous features of Jacob the Giant. If anyone did look at Henry, he fancied they might mistake him for one of these fabulous people. So fabulous that someone like Rebecca Saunders made the thing he was so ashamed of feel like an artful embellishment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry watches the interviews he recorded when he was writing his book. Although the light falls and fails, he doesn’t turn on the lamps, just lets the glow from the screen wash the room. He can hear his twenty-nine-year-old self talking to Rollo, the man in the frame.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This film version of Rollo has reached that perplexing stage called middle age, yet at forty-three he shows no sign of a sedentary paunch. He lounges on the chair like it’s a throne.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So, why clowning?” Henry asks.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He wasn’t interested in Rollo, not really. Henry just wanted to butter him up and loosen his tongue. The man was his closest link to the Saunderses.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why not?” Rollo’s voice is neutral. Henry can see the danger in that neutrality that he wasn’t socially adept enough to pick up on back then.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s not the most glamorous of acts.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No? Not dignified enough for someone of your intellect? A child’s diversion?” Rollo’s mouth contorts into a sneer. “Clowning is the most complex of entertainments. We have the greatest breadth of skills of any circus performer.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry can see how he had been caught out, having to rack his brains to conjure up the man in full regalia, under the spotlight’s glare.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I remember that you came into the big top standing on a zebra’s back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And you were locked in with the lions.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The audience had gasped, fearful when they thought he was in danger. Then Rollo turned from bumbler to lion tamer, cracking the whip with aplomb.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right. I was an acrobat, actor, I did elephant and lion work, I was a bareback rider and a high wire walker, among other things. But clowning is more than that. It’s Greek, don’t you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Clowning. It’s comedy. It’s tragedy. It fulfills a basic human need. Did you know that priests and clowns served the same purpose in ancient Egypt?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, I didn’t.” Henry’s voice is small. The clown’s no fool. Henry musters up all he knows about clown taxonomy to try and redeem himself. “You led the troupe as an auguste, not a blanc?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Blanc, the white faced, dignified straight man of the act. “Auguste is more interesting.” An auguste clown’s face was a riot of color that exaggerated the features. Rollo wore a matching shrunken suit that exaggerated his size. “It’s a better character. A troublemaker.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How did you know the Saunders family?” Henry was keen to steer Rollo toward the subject.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They took me in. His mother, Lil, did gun tricks. Leo and I grew up together. I was hanging around the Minolta State Circus after I ran away from an orphanage.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You ran away to join the circus.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Listening now, Henry’s face burns at his own glib attempt to lighten the mood. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“To join the circus,” Rollo repeats, his face set hard enough to smash Henry to pieces with a look.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You knew them well then. You were almost family.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("were ")]), _vm._v("my family,” Rollo corrects Henry, “the only family I’ve ever had. Lil taught us guns. Leo and I were both crack shots. Leo was sixteen when she died. I was fourteen. Christos, Leo’s brother, was only five.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Where was their father?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tuberculosis. Giorgio died when Christos was a baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What happened after Lilia Saunders died?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was hard. As much as people tried to look out for us there’s no room for dead weight on the road. We stuck together. My real talent was for clowning. Leo did gun tricks but he wanted to build an empire, even then. He saved every penny and when he was twenty-five he mortgaged a patch of land outside the city. He named it Paradise. He asked me to go in with him at the start but I said no. Can you believe that? I told him it was too big a risk.” Rollo looks out of the window. “He was going to give me a second chance at it. He was going to make me a partner before he died. The lawyer told me afterward. All the paperwork had been drawn up. That’s life, I suppose. You don’t get to roll the dice twice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Rollo looks back at him, envy and awe shine from the man’s face. “I should’ve known if anyone could pull it off, it was Leo. He knew how to sell his vision. All those factory workers and waiters. All the soldiers and sailors on leave. If you wanted a tattoo or your palm read, or to look at dirty pictures on a peep show machine, it was all there. A Ferris wheel, side-shows, and a big top.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Youngest clown ever to lead a troupe. More than that, I was Leo’s right hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What about Christos?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leo had been dragging him around for years. Packed him off to college in the end.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They didn’t get on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Growing pains, that was all. No, the real trouble started when Chris came back.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo Saunders sees the girl first. She strolls without the urgency of someone in search of work, but it’s too early in the day for punters to visit Paradise.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She stops to watch Rollo, stripped to vest and trousers, as he limbers up. The man’s all muscle and steam. Sun glints off his shaven head. Even when he’s in his clown costume he can look threatening when he chooses to. Leo’s spent a lifetime pulling him out of scrapes and stopping him from brawling, a relationship that began when he caught Rollo stealing from his mother’s caravan. Lilia was about to give him a whipping but Leo had pleaded for the urchin and she’d said, “All right, but you’re responsible for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo rolls toward the girl like a bowling ball that’ll knock her down. He comes to a stop inches away from her face, looking down at her with a grin. Leo’s seen him do this before to make a pretty girl shriek.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She doesn’t seem startled, just gives Rollo a tight, polite smile as she moves away. That amuses Leo. Rollo’s not used to women walking away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She could be anywhere between eighteen and twenty-five. Her dress is cheap, cherry-patterned nylon, the type that can be hand washed and left to dry overnight. Ugly, sensible shoes and a cardboard suitcase.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nothing can disguise her loveliness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jack,” Leo says to his foreman, “give me a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo, at thirty-three, has the bearing of an older man. He’s used to being obeyed.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure, boss.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo starts to walk over to her. He’s glad he’s freshly shaved and smells of cologne. That his suit’s been pressed. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The girl stops Nancy Fotheringale, the Wax Lady. She’s a permanent fixture in Paradise, with her own tent. Stiff and English, she drinks her tea with her little finger stuck out, now making her living by being an exhibit because she lost her post as a governess when her condition became apparent. The girl bows her head toward the older woman where most people lean away because Nancy’s face drips with pendulous tumours. She looks like she’s melting. The girl speaks and Leo’s surprised when Nancy laughs, a rare and beautiful sound.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Nancy points toward him as he approaches. “Hello, I’m Leo Saunders.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leo,” the girl repeats.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Short for Leonides Saunderis.” He surprises himself. He never begins a conversation with an admission of his immigrant roots.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leonides,” her voices softens, as if more impressed with honesty than reinvention. “It’s a regal name.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It’s as if she’s seen his heart, his fears, his insecurities and, in telling him that Leonides sounds regal, has given him back his real name.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re Christos’s brother, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He grins. It’s not often that he’s referred to as Christos’s brother. “And who are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m Rebecca. His wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Apartments line one end of Paradise. The premium on land prices has made Leo build upward, space insufficient for bungalows for all the performers and key staff. Each block has three stories and they occupy a natural bank, so they have a view of the site.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("From here Leo can see the crowd spill through the turnstiles. The marauding public wear their weekend clothes, pockets of pennies to spend on shooting games and cotton candy. Leo watches their progress toward the side tents where the brave ones look through screens at regulars like Nancy Fotheringale and touring artists such as William Lloyd the Wolf Man and his cubs. The big top rises above it all, its stripes visible from the city.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo’s apartment doubles as an office. There’s a filing cabinet and a map of Paradise, its plots numbered and listed below. There are duty rosters, invoices, and ledgers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo sits with silver picture frame in hand. Lilia and Giorgio Saunderis are dressed for their wedding. Both brandish a pair of pistols.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I thought you’d gone to university to get a degree, not a wife.” Leo puts the frame down.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I love her.” Christos is unabashed by love. He perches on the edge of his brother’s desk.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did she tell you to leave college?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She begged me to stay on.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo sighs. “Then she’s got more sense than you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why’s everyone so angry? It’s my life. Jacob’s furious.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He thinks you’re wasting your talent here. That you could be a physics professor, if you wanted. He spent all those years tutoring you. He never asked me for a penny in return.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And I’m grateful, but it’s not what I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I promised Ma that you’d have an education and a better life than she could give me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She meant well but she shouldn’t have set us on such different paths. What about what I want?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Don’t push too hard")]), _vm._v(", Leo thinks, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("or you’ll push him away")]), _vm._v(". “Okay, what "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("do ")]), _vm._v("you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“To come home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They’re both on their feet. As Leo hauls Christos into an embrace he’s struck that his brother’s not a stripling anymore. Leo’s invigorated by the strength in his brother’s arms.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I missed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I missed you too. Let me work for you. I’ll prove myself. You’ll like Rebecca, I promise.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo pats his brother’s back. “I already do.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry speeds up and slows down the motions of Rollo’s face, until he finds the part of the interview that he wants. Rollo has the physiognomy of a pugilist, not a clown.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo was going through a good phase at the time. The man swings between dry and soaked. Just when Henry thinks Rollo’s got his life in order, things go wrong for him. It’s always someone else’s fault. His boss or his last wife.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo, did you get on with the happy couple?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure. I was like a brother to Christos. I brought them a puppy as a welcome gift. Rebecca named it after a dog she had as a kid. She said every dog she’d had since was named after it. She was a quirky girl.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tell me about Rebecca.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Everyone thought she was great. She was private though. What did you find out about her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Not much. I’ve found a cousin but she won’t see me. Did Leo and Rebecca get on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Well enough at first. I never saw them fight but things cooled after a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She was attractive. Leo was a red-blooded man.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He tried it on with her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t say for sure. Power turns men’s heads. They think rules don’t apply to them. Whatever happened, Leo started to see them as rivals, with Rebecca pulling the strings. Then there were questions about money going missing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why did they continue working together?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leo was a subtle, patient man, even when he was angry. He couldn’t turn Chris out. He’d promised Lil. And he saw Rebecca’s worth straight off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Her act.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I saw her. She was special.” Henry can hear the ache in his own voice.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes,” the clown smiles, “but "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you ")]), _vm._v("never got close enough to feel the heat. She was sublime.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo knocks on the door of the neighboring flat that belongs to Christos and Rebecca.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m early. Sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nonsense.” Rebecca’s barefoot and gracious.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I want to apologize for the poor welcome.” He puts down a basket and hovers by the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She hands him a tall, cool drink, beads of moisture already forming on the glass. His mouth’s suddenly dry. He takes a sip.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Christos was supposed to get here first to break the news but his train was delayed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why didn’t you travel together?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I was visiting my cousin in Lauders. I understand, you know. You’ve looked after Christos all your life. He kept all the letters you sent him while he was in college. He read them when he was lonely.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos, alone. Leo’s most sensitive nerve reverberates.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I love him too.” She touches his arm. “I’ll never hurt him.” He looks at her naked feet, her nails the pale shade of shells. “Talk’s cheap.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’ll see. I’ll prove it to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos comes out of the bedroom. It’s too late in the day for his hair to be so disarrayed. Leo looks away and is glad when he remembers his gift.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve got you something.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo fetches the basket from by the door. Rebecca opens the wicker flap and picks out the quivering body and cradles it against her chest. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Chris said you wanted one. He’s just a mutt but he’s cute. Mainly spaniel from the look of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She holds the puppy up. It’s all eyes and paws.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’s gorgeous. Can we call him Sam? I used to have a dog called Sam when I was little.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sam it is.” Christos scratches Sam’s neck. “We’ve something else to tell you. Rebecca’s got an act of her own.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Doing what?” Leo’s surprised she’s one of their tribe.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I shan’t tell you.” She kisses Sam’s head. “I’ll show you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Where are you going?” Rollo follows them to the big top. “What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo looks at Rebecca for permission. She’s wearing a robe over her costume. She shrugs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Once inside Leo dismisses the sweepers who file out, grumbling that their work’s not done. Leo sits on an upturned crate, Christos beside him, but Rollo contrives to insert himself between them, an arm around their shoulders.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca drops her robe. It lands around her feet in a way that makes Leo’s heart stop and start. He glances at Christos. His brother’s eyes are shining.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her costume’s made of rough, fire-retardant fabric, cut and stitched into a short flared dress that skims her thighs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She holds her right hand out to one side. The flame starts as a flicker in her palm that grows. She undulates as if rolling it up her arm and across her shoulders and then lets it come to rest in her other hand. More flames appear, one then another, not just along the path the first flame had taken but on her chest, her stomach, and her legs. They move at random, growing in size.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca tosses them into the air, juggling with rapid movements that make the fireballs look more like streaks. It looks like she’s fumbled a throw and one of them will land on top of her head but Rebecca puts her head back and opens her mouth, swallowing it. In they go, one after another. Fire’s flying from her hands as if from nowhere and she gulps them down in quick succession.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There’s a pause, in which Leo thinks she’s finished, but then smoke and sparks pour from her mouth, followed by a jet of flames that shoots twenty feet in the air. There’s a flash, then it falls, covering her from head to foot, and Leo starts forward but is restrained by Christos’s hand on his shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca claps, a single sharp sound that seems to douse the flames. Done, she awaits judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s in your accelerant?” Rollo asks. “That’s my secret.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo turns to Christos, who holds up his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can’t work here unless you tell us. There are no secrets from management.” Rollo’s looking at Leo, waiting for affirmation.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can do more than this, Leo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“May I?” Leo stands close. He touches her jaw with his fingertips.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She opens her mouth and he looks inside. Not a blister, not a mark. It looks entirely normal. Nor is a single hair or eyebrow singed. He’s not fond of fire acts or the arcana of the craft. He knows the tricks. How to harden the skin with a mixture of sulphur and alum, to which some add onion or rosemary essence. Afterward they have to soak off this toughened skin with hot wine. Then there’s what they use to coat the delicate flesh inside the mouth: concoctions of more sulphur and alum, this time with soap and carbolic acid. Rebecca’s skin is soft, not callused, and she smells sweet, not like the bowels of hell. He won’t press her to tell him her secret, not yet, not if she’s not told Christos.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You like danger.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo’s seen his share of its ill effects. What happens when the wind unexpectedly shifts and immolates a performer. The awful condition, fire lung, which follows accidental inhalation of the fuel being held in their mouths. He’s also seen the longer term consequences of this game: the stained, bleeding gums and then the florid, fungus-shaped cancers of the throat and tongue that fire swallowers are prone to.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know the risks. You’ve not told me what you think of me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re good. You’ve been practicing but you’re new to this game.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is it that obvious?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Only to me.” Leo smiles despite himself. “It’s about presentation. We can teach you that stuff, if you really want to do it. I want you to know that you don’t have to, though. None of us expects it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos, why did you bring her here? If she were mine there’d be a house with a lawn. Or an apartment in the city with a view, just a short walk from the theater.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Anything she wanted. Just not this")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His existence seems shabby despite all his enterprise. He’s a vulgar showman grubbing in the dirt for coins.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Are you joking? She’ll be a star.” Rollo’s praise sounds sour. “I was born for this,” Rebecca insists.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Then you’re going to need a better costume. And a name.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We’d been on the road all our lives. Leo gave us a home. Rebecca messed everything up. Afterward it all fell apart. We all went different ways.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry has sat up all night, watching Rollo’s interviews again and again.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“For people who are unique you’ve proved hard to find.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who have you talked to?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“People who worked in Paradise but no one else from this photo.” Henry sees the back of his own head as he leans into the camera shot to hand Rollo the photograph. It’s the one of the group dressed for dinner.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo clutches it, dumb. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Looking at a past he can’t get back")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll send you a copy.” Henry retrieves it. “You stayed on in Paradise for a while.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Until you were sacked.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Trumped-up excuses. They had no idea what they were doing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You mean Flint’s men?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Flint,” Rollo sneers, “inherited wealth. His father was a match tycoon. William Flint had no business sense, didn’t know show people or the public.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Paradise limped on for a few years before it closed.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It survived on notoriety. The papers loved the story.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry knows all their ridiculous theories. That the brothers faked their deaths to embezzle from investors, despite the bodies in the morgue. That Rebecca Saunders was wife of one and lover to the other and it was a suicide pact.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I didn’t want to stay anyway,” Rollo frowns. “I left and took my troupe with me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry doesn’t correct him. He knows from looking at Paradise’s payroll records that only half the troupe followed Rollo.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You didn’t stay a clown long after that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“My heart wasn’t in it anymore.” Rollo has had a long list of careers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You seem so happy and proud when you talk about circus work.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Happy? I don’t think I was happy ever again after that day.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What do you think really happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo’s eyes are so dark that Henry can’t make out the pupils. “Leo had handled guns since he was a child. As for Rebecca, even Chris didn’t know her methods. I’ve never understood it.” Rollo shakes his head, a man perplexed. “Not at all.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Night. Revelers and gulls head home. Rebecca and Leo are out on her apartment balcony, looking down at Christos and Rollo as they collect the turnstile takings and lock up for the night. Lights are going out in the booths around Paradise. Those who don’t live on site are leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo’s not enjoying Christos’s company.” Sam sits at Rebecca’s feet, eyes fixed on her in adoration.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo’s used to being close to you. And being important.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo’s well looked after. What’s bothering you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Christos has been over five years of accounts. He thinks someone’s been skimming off the gates’ take.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who?” Leo holds her gaze. “Christos says he doesn’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She looks at Rollo and Christos. “Rollo doesn’t like being watched.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll talk to Chris. I wasn’t expecting him to be so thorough. I know about Rollo. As long as he doesn’t get greedy I let it go.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo can’t help himself. This stops him from doing something even more stupid.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s very understanding.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When we found Rollo he scavenged and stole like an abandoned mongrel. Part of him will always be unsure where the next punch or plate of food’s coming from. He’s not the thug he pretends to be.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He just needs people to give him a chance. He needs family to look out for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’s lucky to have such a family.” She says "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("family ")]), _vm._v("like it’s the grail.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re part of it too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve not been part of anything for a very long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’ve had it tough.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Haven’t we all?” Leo chuckles ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Chris looks like our dad. Tall, handsome. Girls like that.” He regrets the words straight away. He sounds self-pitying. He knows Rebecca doesn’t give a shake of salt for looks. “He’s had a bad time. Motherless. Fatherless. A childhood on the road. But sometimes, when I look at him …” His thoughts are tangled.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s like he’s untouched by it.” It’s alarming how she unravels him. “He hurts like the rest of us but life’s not destroyed his joy or innocence. That’s why we both love him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo’s heart twists in his chest. He’s become accustomed to the sounds of their life as man and wife filtering through the thin wall. Rebecca singing, the unsteady rhythm of the shower, and, worst of all, peals of laughter followed by a silence that leaves Leo dead inside.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He can’t allow this.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then he thinks of her at the center of the tent, illuminating the faces in the crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Pernicious love. It burns us up and leaves charred husks.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And yet she warms him, through and through.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo puts an arm around Christos’s neck as they walk away from the turnstiles. When Christos sees his wife and brother he shouts up to them. Rebecca waves back, her whole arm in motion and her smile wide.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do you think she’s happy here, Rollo?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure. She’s a big hit. Everyone loves her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Even Leo?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’s come around to the idea. She was a surprise, in more ways than one. But what about you, kiddo? How are you settling in?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s good to be home.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Of course,” Rollo ruffles Christos’s hair. “All I meant is that I thought you were looking to do something else with your life. I never figured you’d want to be part of this.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I liked studying but I never felt like I belonged out there. It’s so gray, Rollo. I realized how much I love it here. The only problem is that I don’t know enough about the business. I mean, Leo knows it all. Inside out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leo kept you out of things. It was what Lil wanted.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I know,” Christos pulls a face, “but I’ve a lot to learn if I’m going to become more than a bookkeeper.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m going to need to make an impression if I’m going to be Leo’s partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Partner?” There’s a long pause. “Wow, that’s really something, isn’t it? I couldn’t be happier for you.” Rollo’s words are falling out now, one after another, “a real family affair. The Saunders brothers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They walk on, silent, until Christos says, “It’s important to me to be more than Leo’s little brother.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo’s reply takes a beat too long.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t be too hard on yourself. Leo’s a hard act to follow. He’s done everything from selling candy to performing. That’s why he’s so respected. Show people will listen to him. He and your mother were legends.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The double-bullet catch.” Christos sighs.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No other family has performed it. And Leo is still the youngest ever at fourteen.” Rollo sounds wistful. “Lilia was fearless, even with her own son. No one will see the likes of it again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos is silent, swallowing every word.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry turns off the recording of Rollo. Something nags at him. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He opens his book. The group photo’s lodged between the pages where he left it. This time he looks at the cropped version reprinted within.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It smacks of glamour. Rebecca Saunders looks like a film star. She has a strong, pointed chin. Her hair’s scraped back despite the fashion for piled-up curls. Her mouth’s mid-laugh and her eyes downcast. Her peach skin’s lost on monochrome film. Her dark gown’s shot with silver that glitters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos looks straight into the lens. Henry wants to dislike him: his narrow nose, long hair touching his collar, an arm around Rebecca. It’s at odds with Rollo’s portrait of a usurper and thief. Christos looks starstruck by love and, God help him, like an innocent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I shouldn’t begrudge him their time together, knowing how it ended")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The dog looks straight into the camera too. Christos holds his collar with his free hand. The dog. Something about the dog.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry picks up the phone. “The Gramercy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’d like to speak with Roland Henrikson. Room 136.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He waits, the phone ringing in Rollo’s room. Henry’s kept track of him, all these years.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” Rollo’s voice is thick with sleep. He’s currently on a downturn, a sad state because at seventy-eight life should be easier.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ve woken you, sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What’s the time?” He can hear Rollo fumbling with a clock. “Henry, it’s eleven in the morning. What do you want?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rebecca’s dog.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You got me up to ask about a dog?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What happened to it after they died?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think it got sent to her cousin, along with her remains.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“This is the dog you said you bought them.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s right.” Rollo sounds wary. “You didn’t want to keep it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why would I?” Rollo pauses. “I’m sorry, Henry. I’ve got a bad head.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry takes "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("bad head ")]), _vm._v("to mean "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("bad hangover")]), _vm._v(". “What was it called?” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The dog’s name. You said she always gave the dog the same name as the one she had as a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh God, it was a long time ago. Bobby. I’m pretty sure it was Bobby.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry closes his eyes. The back of the photo listed the group’s names, including the dog, Sam. Rollo should know that.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Have you got a lead?” There’s the sound of Rollo gulping from a bottle.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m not sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Call me if you find anything new. They were my best friends, you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hey, Henry, I don’t suppose you could do me a favor?” Henry knows what’s coming. “I’m a bit short this month. I don’t suppose you could wire me some money?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" “Do the double-bullet catch with me or I’ll find someone else who will.” Christos is adamant.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Like hell you will.” So is Leo. “You can’t stop me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can. You can’t perform here without my permission.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll find somewhere else.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo gives Rebecca an imploring look. “Talk some sense into him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leave her out of this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She’s your "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("wife")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t do it.” Rebecca’s ashen. Christos clutches her hands in his.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nobody will take me seriously unless I do something like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What are you talking about?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“They look at you with awe,” he says to Rebecca. Then he turns to Leo, “I’m just your little brother and always will be until I prove I’m as good as you.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Don’t be ridiculous.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll ask Rollo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And Rollo will say no. I’ll make sure of that.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll go to Jim Shaw. He knows guns.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo wonders how Christos is so well informed and ignorant, all at once.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jim Shaw shot the fingers off a man last year.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’ll have to do, if you won’t help me.” Christos walks out of Leo’s office.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Is it true about this Shaw man?” Rebecca asks. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Do it with him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca stands so close that Leo struggles to keep his breathing even.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re the only person I trust to keep him safe.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Betty Marlin, Rebecca’s cousin, basks in the sun. Her head’s thrown back and her hands folded across her middle. Henry puts her in her mid-sixties, or thereabouts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I hope you don’t mind sitting out here. I like the heat. Help yourself to lemonade. It’s homemade.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry wishes she’d remove her sunglasses and do him the courtesy of taking him into the shade. He can’t tell if there’s a family resemblance. She’s wrinkled from sun worship, with thinning hair cut into a bob. She wears long shorts and a vest.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The plastic chair creaks as Henry sits down. “Don’t you hate being old?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry wonders what he hoped to gain in coming here, all the way to Lauders.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t stand it,” she continues. “It feels like penance.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her chatter’s girlish, as if age is a mask that can be stripped away. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s not vanity. It’s feeling out of step with the world that bothers me.” Betty talks without pause. “I don’t understand young people. They’re so ambitious but they don’t seem to enjoy life. Do you have children?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Pardon?” Her sudden question wrong foots him. “Children?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A daughter. She’s thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Does that help you to understand them?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” he laughs, then realizes how he’s been sidetracked. “Thanks for finally agreeing to see me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t like journalists.” She takes off her sunglasses. She doesn’t even look at his birthmark. There was a time when that would’ve thrilled him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m not a journalist. I’m a historian.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Historian?” She slips the glasses back on.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I was a lecturer. I retired last year. I sent you the book I wrote, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Firebrand")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Oh, that. I didn’t read it. And I told you years ago, on the phone, what I know about Rebecca.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Betty’s dog has been sniffing at him. It’s a broad-chested boxer with an air of stubborn loyalty. Satisfied, it sits at Betty’s feet. Henry can see his own reflection in her dark lenses.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The official version of events is wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was an accident.” The girlishness has gone. “Rebecca took revenge for Christos’s murder.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He leaves her with that incendiary while he takes a sip of lemonade. It’s too sharp for his taste.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Good luck with that idea.” She leans over and pats his hand in a way that offends him. “See yourself out.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She gets up and goes in.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The dog escorts Henry to the gate. On a sudden impulse Henry says, “Sam.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The dog’s tail thumps the concrete slabs and then it gets up and trots on the spot, excited at this sudden familiarity. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca named it after a dog she had as a kid. She said every dog she’d had since was named after it.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry goes back up to the house and stands on the porch, blinded for a moment by stepping from light to dark. Sam goes ahead through the open door, claws clipping on the wooden floor.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry listens. There’s the whirl of a fan and a radio. He goes inside.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rebecca?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Betty’s there. Waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nobody’s called me that in a long time.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Two walnut cases. One their mother’s and the other their father’s, each containing a pair of guns. They are the Saunderis legacy and they make Leo queasy with horrid fascination. He’s never more afraid than when one’s in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("These guns fed and clothed us when we first came to this country. Never sell them. You’ll always have a living")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It’s not too late. I can do a single-bullet catch.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos is pale and excited, on the cusp of imagined glory that will somehow make him whole.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No. We’re doing this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I think we should make it an even more special night. Announce that you and Rollo are going to be partners afterward. What do you think?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I can’t wait. You should’ve seen his face when I was coming in on the business.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You told him?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Just about me. I was teasing him. Can you imagine how happy he’ll be when he realizes it’s the three of us?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You shouldn’t joke with Rollo like that. He’s touchy. I wonder why he never said anything. And why the hell didn’t you tell me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sorry. I was preoccupied with this. Don’t worry. It’ll make it a bigger surprise for him.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They are at the side of the stage. Rollo’s out front, warming up the audience.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You both look wonderful,” Rebecca says as she joins them. They’re wearing tailcoats and starched shirts. Then to Christos, “I love you. I won’t love you any less if you call it off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos silences her with a full-mouthed kiss.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then Rebecca puts a hand on Leo’s chest, over his heart. “Promise you’ll look after him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I promise.” A life of promises to women, Leo thinks. It’s time. Brothers stand side by side.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Remember you’re not aiming for my head,” Christos jokes.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There’s a roar as they run on. The spotlights fly about and then settle on them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Ladies and gentlemen, welcome!” Leo’s voice booms through the tent that’s been arranged with a stage at one end. Care’s been taken about the positioning of the benches. Nothing puts off punters like a stray bullet into the crowd. Even a painted wax bullet can kill a man.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo lowers his voice to draw the audience in.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What you’re about to see has only been done four times. The last performance was by myself and my mother,” he pauses to give her back her proper name, “the famous Lilia Saunderis.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It’s Christos’s turn.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“People have died doing bullet catches. My brother and I will perform a double-bullet catch for one night only. You’re going to witness history, a feat performed twice by one family!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo steps up.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We’re trained professionals. Don’t repeat this at home. If you’re of a nervous disposition we advise that you leave now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca brings out a single case. She’s dressed as the Firebrand. Her costume glints in the light. Leo’s chosen his mother’s guns.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We’ll need a volunteer from the audience.” The spotlights are set swinging. They whirl about the audience. A drum rolls and there’s a hush. Christos drops his raised arm and the lights land and shrink to reveal two faces at opposing ends of the tent.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come on down!”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The first is a woman, dressed in a cotton smock and clogs. She looks overawed, blinking in the light. Rebecca has put down the case of guns and goes to meet her, smiling like she’s welcoming a friend.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Madam, what’s your name?” Leo enquires, taking her hand. Her skin is rough and red from country living.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Sally.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you for your help, Sally. Would you mind waiting here for a moment while we meet our other volunteer?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca holds his arm. It’s a man dressed in work boots and a shirt. He has an everyman face, essential in a shill, a circus man that Leo trusts. He’s not willing to chance his brother’s life on a real volunteer. Bad luck that it would be some wisecracker, the sort who’d load something else into the gun for a laugh.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“And your name?” Christos asks. “Jack Milner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Thank you, Jack. Do you know guns?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A little.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“These are Delfontaine’s Rangers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“If you say so.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The audience laughs. Rebecca carries a tray over to them, aloft on one hand. On it there are a pair of bullets and a pocket knife. “Now, Jack, would you do us the honor of marking these two bullets so that we can identify them later?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is a pause while Jack scores the bullets’ casings with the knife. “Now, Sally, I want you to take a good look at these as you’re going to see them later.” Leo hands her one bullet and waits, giving her time to examine it. “Happy? Good.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Christos takes the second bullet from Jack, repeating the ritual. Leo watches, pleased with Chris’s sleight of hand. After Sally’s inspection, they’ve both swapped the bullets, replacing them with fake ones on the trays.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo hates this part. The feel of the real bullet that he’s palmed and hidden in his mouth. The taste of metal filings that cling to the case. “Now, Jack, we’re going to ask you to load one bullet into each gun.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Jack the shill obliges, putting the fakes into the gun barrels.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Here it comes. Leo and Christos stand back to back like duellists at dawn. There’s a drum roll. They each count fifteen paces. They’ve been drilled by Rollo until their timing’s perfect. He’s even done target practice with the brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("They turn. Leo takes aim. Both of them have been careful to consider angles.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo squeezes the trigger. The sound deafens him temporarily. Something’s wrong. Christos looks at him, bewildered. There’s a slow trickle of blood from the hole in Christos’s forehead. It gathers in his eyebrow and falls in heavy drops. He staggers and then pitches backward.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Someone, maybe Sally, screams.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" “How did you know?” Rebecca’s in the lounge. Henry stands in the doorway.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A hunch. I remembered that you always called your dog by the name of Sam. It got me thinking.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“How astute.” It doesn’t sound like praise. “I saw you and Leo burn.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You were there?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes. I was only eighteen. You should be dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Come and sit down so we can talk.” Rebecca’s voice softens. “Is Leo alive too?” Anything’s possible.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No, Leo’s dead. You saw it yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I saw them take "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("your ")]), _vm._v("body away.” A charred corpse laid on the tarpaulin.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Why have you pursued this?” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He can’t verbalize it. “I came to see you as often as I could.” Rebecca’s look is both amusement and bemusement.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’ve fallen in love with your own fantasy. That’s about you, not me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I need to know what happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You weren’t part of it. You were just a spectator.” It rankles that he has no claim to her tale.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m a witness.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re a pompous ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She isn’t the sweet girl of his imagination. She has no truck with romance. He wants to shock her into revealing the truth.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Your husband was murdered by his own brother and I think you burnt him to death to get revenge.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was an accident.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“It was a live bullet. It’s all in the book.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I didn’t read your book and I don’t believe it. Leonides would’ve cut off his own arm before he hurt Christos.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The bullet they found at his autopsy was real.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What possible reason would Leo have?” She stares at him. “He found out Christos was robbing him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Christos wasn’t a thief. And Leo wasn’t a murderer. Who told you that?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She rocks back and forth, roaring with laughter that dies in her throat as fast as it starts.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I might have known that he’d do for all of us in the end. He was the one with the light fingers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What do you mean?” This rapid revisionism makes Henry weak. “Leo trusted Rollo. He was going to make him a partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Leo was going to make Rollo "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("and ")]), _vm._v("Christos partners. It was a mark of the man that he overlooked Rollo’s thieving and treated him like a brother. Where did you get the information for your book? Rollo? He was an inveterate liar and crook.” Her derision’s on her face. “You should’ve known better, professor.” ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t understand. The bullet was fired from the gun they found on the floor.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did you know there was a second set of guns?” Rebecca doesn’t give him time to digest this. “Rollo was backstage. He could have fired his gun in time with Leo and then swapped it in the confusion.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Rollo?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo. He thinks of the interviews.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo and I were both crack shots")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rollo. With his insinuations about the Saunders brothers. That one was a thief and the other a lecher and a murderer. And Henry’s believed Rollo, who’s always on the make, always touching him for money, because there was no other way to get close to Rebecca.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Can I ask you something?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Did Rollo buy you a dog?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“No,” she looks perplexed. “Leo did.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She’s telling the truth. She has no reason to lie to him; she doesn’t care one iota for what he thinks. Henry can feel the mocking weight of his book in his pocket. He’s not recorded history. Not even memory. He’s been a scribe for lies. Rollo’s not just a liar. He’s a killer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“He’s still alive, isn’t he?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry can’t meet Rebecca’s eyes. “How are "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("you ")]), _vm._v("still alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’ll show you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He follows her into the hall. There’s a door beneath the stairs. “Stay,” she wags a finger at Sam. Then to Henry, “Shut the door behind you. I don’t want Sam down here. He’ll get upset.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A bare bulb lights their descent. The basement’s bare. She turns to face him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“That’s quite a birthmark to carry around.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca’s direct. The statement carries expectation. She expects something in return for what she’s about to show him. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When I was a child my father took me to a specialist about my face. I remember how Dad looked when the doctor told him that nothing could be done.” Henry’s surprised that of all his memories this is the one he’s seized upon. It’s been just beneath the surface all this time. “The only time he ever touched it was when one of his friends made a wisecrack. Dad took me home and scrubbed my face as though it was an ink stain that could come off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The words rush out of him. “When my daughter was born and I held her in my arms, I was so overwhelmed by her that I couldn’t imagine anything that would make her seem less than perfect to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("After the divorce, things between them had become difficult. Henry can’t recall the last time he spoke to his daughter. He wishes he’d tried harder.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The first time I saw you, Rebecca, you reached out and touched it.” He puts his fingertips on the stained side of his face, recalling the moment.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t remember. You’re afraid, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“So you should be. I’ve not brought many people luck.” She snaps her fingers and a single flame appears. “I’ve never talked to anyone like this. Not even Chris or Leo. I wish I had.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Her whole fist’s burning. She lifts it like a torch. The light reflects in her eyes. “Fire’s a funny thing. People think we’ve tamed it but they have no idea. It turns on you when you least expect it. When I saw Christos lying there, it got out. I was so shocked that I couldn’t stop it. Leo must’ve thought something had gone wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Small flames gutter around her like a cloak.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know. The first time, I burnt up my lover in a fit of lust. When I woke up I was entwined with his corpse. I had to crack my charred skin off the new flesh beneath. Every time I allow myself to fully burn up, I’m a woman of twenty again. I’ve survived cancer and two heart attacks this way. And being fireproof saved me at Salem. I was the corpse that wouldn’t burn down to bone. I clawed my way out of a mass grave.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("She’s eternal, elemental. Henry steps back. She’s roaring now.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He can feel the heat on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The real trick’s not being a human bonfire. It’s what I do with myself afterward.” He thinks he can see a smile within this pillar of fire. “I always leave my effects to my cousin and I’m never in my coffin when it’s buried.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The light bulb shatters. She’s the only light in the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Then the flames die as if she’s sucked them back inside herself. “Rebecca?” He’s scared she’ll answer.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Take Sam with you,” she says in the lull before the sudden flare that fills the room. The blast blows Henry off his feet. He turns his face away. The flames pass overhead and then recede. He can smell his own singeing hair. She’s an inferno. He crawls to the stairs. Fire’s licking the walls and creeping along the ceiling beams. He can hear Sam, barking and flinging his stocky body at the door. Henry snatches at Sam’s collar and heaves the snapping, straining animal outside into the quiet dusk of the suburban street. It takes all his strength to keep hold of Sam as he collapses on the tarmac, arms around the dog’s chest. The fire is fast. Henry can see the warm glow through the windows as it feeds, then something inside the lounge explodes. The window shatters.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry has to leave now, while he can. People are coming out of their houses. He goes, dragging Sam into the coming darkness and silence, back to feeling like he always has, alone, waiting for her light.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Henry’s already awake to hear Sam barking. He doesn’t sleep well anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Life’s nothing but silence and darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He turns on the bedside lamp. The newspaper is still on the nightstand, folded at the page that carries Betty Marlin’s obituary, the final flourish of Rebecca’s preparations for her latest death. ")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("His body creaks and groans as he goes to the front door and opens it, letting Sam run out into the black woods away from him. Henry sits on the step and waits, worrying that Sam won’t come back. He does, eventually, sniffing and pawing at him.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Hey.” He rubs the loose skin on Sam’s neck.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When Henry peers out between the trunks there’s nothing. Not a glow or a flicker to betray her. She’s not coming for him after all. He realizes the worst of it. That he’s just a footnote and Rebecca has turned the page.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The leaves are coming in, good and green. Henry likes this time of year. He’s decided to stay in the house at the end of the lane, with its view of the trees. Sam likes it here.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He’s been on the verge of making the call so many times. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Today")]), _vm._v(", he tells himself, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’ll do it today")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He picks up the phone. “The Gramercy.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Roland Henrikson, please. 136.” The man clears his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sorry, sir. Mr. Henrikson’s dead.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” He thinks of Rollo’s face filling the screen.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sorry to give you such terrible news.” The man waits. All Henry can think is that he’s courteous despite the seedy hotel where he works.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Can I ask how?”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The man clears his throat. “Please tell me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’m sorry. His body was found on a building site. Someone set him on fire.”")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-No-Indent-SpB4--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Leo can’t move fast enough. Christos’s legs have stopped twitching.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You’re the only person I trust to keep him safe.")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca leans over Christos. Leo can’t tell if she’s screaming or not. Everything sounds muffled to him, even the shrieks of the crowd. He doesn’t understand. His aim was true. He wants to tell Rebecca it was an accident. Not even his desire for her could make him hurt Christos. Or her.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca looks up, wet faced. Then she bursts into flames, a rapid progression that’s uncontrolled. This isn’t her act. By the time he reaches her she’s a bonfire. She’s not just engulfed, as he’s accustomed to seeing her; she’s consumed. Rebecca’s burning up.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He takes off his jacket and tries to smother the flames but it’s too late. The fire’s too great. There’s nothing for it. Leo puts his arms around her, marvelling that she still has the strength to try and push him off.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It hurts at first. His skin sears but he won’t relinquish her. There’s insufficient smoke to choke him. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Let it come")]), _vm._v(". His sordid corners cry out to be purified by fire.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Rebecca’s embrace is hot. Hotter than the center of the earth. Hotter than the surface of the sun. She’s holding "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("him ")]), _vm._v("close now and he wishes he could see her face at the heart of the blaze. There’s no one now but the two of them.")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Body-Text-Indented--Body-",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Love")]), _vm._v(", Leo thinks, "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("how it burns us up")]), _vm._v(". ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50910008","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nightmarecarnivalepub23.vue
// module id = 84
// module chunks = 0